<template>
    <div>
        <div class="card my-3">
            <div class="row" v-if="count == 0">
                <h6 class="col text-center my-4">You don't have any messages here</h6>
            </div>
            <ul class="message-list" v-if="count > 0">
                <li :key="i" v-for="i in count">
                    <one-message
                            :date="new Date()"
                            :id="i"
                            message="hello, ezdfkhjgbz zkdzhd zdg zgd zd zod z d zd zoy d"
                            sender="Saif Bessassi"
                    />
                </li>
            </ul>
        </div>
        <div class="row mb-3">
            <div class="col-7 align-self-center">
                Showing 1 - 20 of 1,524
            </div>
            <!-- end Col -->
            <div class="col-5">
                <div class="btn-group float-right">
                    <button
                            class="btn btn-sm btn-standard waves-effect mb-0"
                            type="button"
                    >
                        <i class="fa fa-chevron-left"></i>
                    </button>
                    <button
                            class="btn btn-sm btn-standard waves-effect mb-0"
                            type="button"
                    >
                        <i class="fa fa-chevron-right"></i>
                    </button>
                </div>
            </div>
            <!-- end Col -->
        </div>
        <!--end row-->
    </div>
</template>

<script>
    import OneMessage from './one-message';

    export default {
        name: 'list-messages',
        components: {OneMessage},
        props: {
            count: {
                type: Number,
                required: true
            }
        }
    };
</script>

<style scoped></style>
